import React from "react";
import grey from "@mui/material/colors/grey";
import {
  Modal,
  Box,
  Container,
  Paper,
  Typography,
  IconButton,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export default function SpacecastModal({
  isOpen,
  close,
  spacecastData,
  setSpacecastData,
  spacecastArray,
}) {
  return (
    <Modal open={isOpen}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        style={{ width: "100dvw", height: "100dvh" }}
      >
        <Container style={{ outline: "none" }}>
          <Paper
            style={{
              padding: "16px 24px",
              backgroundColor: grey[300],
            }}
          >
            <Box display="flex">
              <Box flex="1" display="flex" alignItems="center">
                <Typography variant="h5">Spacecast Information</Typography>
              </Box>
              <Box>
                <IconButton onClick={close}>
                  <CloseIcon />
                </IconButton>
              </Box>
            </Box>

            {spacecastData ? (
              <Box>
                <Typography>
                  Broadcast at {spacecastData.spacecast_at}
                </Typography>
                <Typography>
                  Right Ascension: {spacecastData.ra} radians
                </Typography>
                <Typography>
                  Declination: {spacecastData.dec} radians
                </Typography>
              </Box>
            ) : null}

            {spacecastArray.length ? (
              <Box
                mt={2}
                style={{
                  maxHeight: "60dvh",
                  overflow: "scroll",
                }}
              >
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Broadcast at</TableCell>
                      <TableCell>Right Ascension</TableCell>
                      <TableCell>Declination</TableCell>
                      <TableCell>Select</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {spacecastArray.filter(sc => !!sc.ra).map(spacecastItem => (
                      <TableRow key={spacecastItem.id}>
                        <TableCell>{spacecastItem.spacecast_at}</TableCell>
                        <TableCell>{spacecastItem.ra}</TableCell>
                        <TableCell>{spacecastItem.dec}</TableCell>
                        <TableCell>
                          {spacecastItem.id !== spacecastData.id ? (
                              <Button color="primary" variant="contained"
                                      onClick={() => setSpacecastData(spacecastItem)}>
                                Select
                              </Button>
                          ) : (
                            <Typography>SELECTED</Typography>
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            ) : null}
          </Paper>
        </Container>
      </Box>
    </Modal>
  );
}
